import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Brain, ChevronDown, ChevronRight } from 'lucide-react';
import { MarkdownText } from './MarkdownText.jsx';

/**
 * ThinkingPane — AI 推理過程折疊面板（預設收起）
 */
export function ThinkingPane({ text }) {
    const { t } = useTranslation('workspace');
    const [open, setOpen] = useState(false);
    if (!text) return null;
    return (
        <div className="my-2 rounded-md border border-cream-200 bg-cream-100/60 text-xs overflow-hidden">
            <button
                onClick={() => setOpen((o) => !o)}
                className="w-full px-3 py-1.5 flex items-center gap-1.5 text-ink-500 hover:text-ink-700 transition"
            >
                {open ? <ChevronDown size={12} /> : <ChevronRight size={12} />}
                <Brain size={12} strokeWidth={1.6} />
                <span className="font-mono uppercase tracking-wider text-[10px]">{t('thinking.label')}</span>
                <span className="ml-1 text-ink-400 normal-case">{text.length} chars</span>
            </button>
            {open && (
                <div className="px-3 pb-2 text-ink-600 italic leading-relaxed">
                    <MarkdownText className="text-xs">{text}</MarkdownText>
                </div>
            )}
        </div>
    );
}
